import type { BrandConfigType } from "@da-web/common";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useBrandConfig = (brand: string) =>
  useSuspenseQuery({
    queryKey: ["brand-config", brand],
    queryFn: async (): Promise<BrandConfigType> => {
      const response = await fetch(`api/brand-config?brand=${brand}`);

      const result: {
        data: BrandConfigType;
      } = await response.json();

      return result.data;
    },
  });
